import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from 'react-bootstrap-table2-paginator';
import useReleases from "../Hooks/useReleases";
import { PaginationRequest } from "../../../api/Common/Util";
import moment from "moment";
import { Tooltip } from "../../../components/Utils/Tooltips";
import { Check, More } from "../../../components/Icons/Icons";
import { useTranslation } from 'react-i18next';
import Loader from "../../../components/Common/Loader";
import { resolveOfferedReleases, resolveRemainingStock, resolveReleaseListInit } from "./inventoryFormRules";

export default function ReleaseList({ initValue, handleSubmit }) {
    const { t } = useTranslation();
    const { itemId, assignmentType, assignId, includeExpired, onlyAvailable, includeStock, onlyWithStock, showStock, filteredFrom, lotOfferRule } = resolveReleaseListInit(initValue);

    const [pagedReleases, isReleaseLoading, navigation] = useReleases({
        preload: true,
        requestProps: {
            ... new PaginationRequest({
                pageNumber: 1,
                pageSize: 10,
                sortColumn: 'lotNumber',
            }),
            onlyAvailable: onlyAvailable,
            includeStock: includeStock,
            includeDetail: false,
            includeExpired: includeExpired,
            itemId: itemId,
            assignmentType,
            assignId
        },
        onlyWithStock: onlyWithStock
    })

    function handleTableChange(type, { page, sizePerPage, sortField, sortOrder }) {
        navigation.ToPage({
            page
        })
    }

    const columns = [
        { dataField: 'lotNumber', text: 'Lot Number', headerStyle: { width: '7rem' } },
        {
            text: 'Expiration date', headerStyle: { width: '10rem' }
            , formatter: function (_cell, release, rowIndex) {
                return moment(release.expirationDate).format("DD/MM/YYYY");
            }
        }
    ]

    if (showStock) {
        columns.push({
            text: 'Stock'
            , headerStyle: { width: '5rem' }
            , formatter: function (_cell, release, rowIndex) {
                return resolveRemainingStock(release, filteredFrom)
            }
        })
    }

    columns.push({
        dataField: 'view',
        text: "",
        isDummyField: true,
        headerClasses: 'header-actions',
        classes: 'row-actions',
        formatter: function (_cell, row, rowIndex) {
            return (
                <div key={rowIndex}>
                    <button type="button" className="btn-table-actions" onClick={() => { onHandleSubmit(row) }}>
                        <Tooltip tooltip={'Seleccionar lote'} id={"tooltipedit-" + row.Id}>
                            <span aria-hidden="true"><Check /></span>
                        </Tooltip>
                    </button>
                </div>
            )
        }
    })

    const onHandleSubmit = (selectedRelease) => {
        handleSubmit(selectedRelease)
    }

    const offeredReleases = resolveOfferedReleases(pagedReleases.Values, filteredFrom, lotOfferRule)


    return (<Loader isLoading={isReleaseLoading}>
        <BootstrapTable
            bordered={false}
            hover
            remote
            condensed
            keyField='id'
            classes="table-spaced table-spaced-small"
            wrapperClasses="table-responsive"

            pagination={paginationFactory({
                page: pagedReleases.PageNumber,
                sizePerPage: pagedReleases.PageSize,
                totalSize: pagedReleases.TotalCount,
                hideSizePerPage: true
            })}

            onTableChange={handleTableChange}
            data={offeredReleases}
            columns={columns}
            loading={isReleaseLoading}
            noDataIndication={() => <>{t("commons.noData")}</>}
        />
    </Loader>)
}